import { EmptyNumberFormatter, EmptyOddFormatters } from "./EmptyNumberFormatter";
export var OddStyles;
(function (OddStyles) {
    OddStyles[OddStyles["american"] = 0] = "american";
    OddStyles[OddStyles["decimal"] = 1] = "decimal";
    OddStyles[OddStyles["fractional"] = 2] = "fractional";
    OddStyles[OddStyles["hk"] = 3] = "hk";
    OddStyles[OddStyles["malay"] = 4] = "malay";
    OddStyles[OddStyles["indo"] = 5] = "indo";
})(OddStyles || (OddStyles = {}));
var DecimalLocalizator = /** @class */ (function () {
    function DecimalLocalizator(config) {
        this.oddFormatters = config.oddFormatters || EmptyOddFormatters;
        this.pointFormatter = config.pointFormatter || EmptyNumberFormatter;
        this.numberFormatter = config.numberFormatter || EmptyNumberFormatter;
        this.defaultNumberFormatter = config.defaultNumberFormatter || EmptyNumberFormatter;
    }
    DecimalLocalizator.prototype.localizeOdd = function (odd, oddStyle) {
        if (!odd) {
            return "";
        }
        return /\d/.test(odd) ? this.getOddFormatter(oddStyle).format(odd) : odd;
    };
    DecimalLocalizator.prototype.localizePoint = function (point) {
        return this.localizeValue(this.pointFormatter, point);
    };
    DecimalLocalizator.prototype.localizeNumber = function (number) {
        return this.localizeValue(this.numberFormatter, number);
    };
    DecimalLocalizator.prototype.localizeNumberByDefault = function (number) {
        return this.localizeValue(this.defaultNumberFormatter, number);
    };
    DecimalLocalizator.prototype.getOddFormatter = function (oddStyle) {
        switch (oddStyle) {
            case OddStyles.decimal:
                return this.oddFormatters.European;
            case OddStyles.malay:
                return this.oddFormatters.Malay;
            case OddStyles.indo:
                return this.oddFormatters.Indo;
            case OddStyles.hk:
                return this.oddFormatters.Hongkong;
        }
        return EmptyNumberFormatter;
    };
    DecimalLocalizator.prototype.localizeValue = function (formatter, decimalValue) {
        if (decimalValue !== undefined && decimalValue !== null) {
            return formatter.format(decimalValue);
        }
        return "";
    };
    return DecimalLocalizator;
}());
export { DecimalLocalizator };
//# sourceMappingURL=DecimalLocalizator.js.map